import axios from 'axios';

const ajax = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    //timeout: 5000
  });

  ajax.CancelToken = axios.CancelToken;
  ajax.isCancel = axios.isCancel;
  
  /*
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  ajax.interceptors.request.use(
    (config) => {
      let token = localStorage.getItem('auth_token');

      if (token) {
        config.headers['Authorization'] = `Bearer ${ token }`
      }
  
      return config
    },
  
    (error) => {
      return Promise.reject(error)
    }
  )

export default ajax;